import React from 'react';
import ReactDOM from 'react-dom/client';
import { hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './style.css';

const rootElement = document.getElementById('root');

// react-snap: si ya hay HTML pre-renderizado, usamos hydrate en lugar de render
if (rootElement.hasChildNodes()) {
  hydrateRoot(
    rootElement,
    <React.StrictMode><App /></React.StrictMode>
  );
} else {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode><App /></React.StrictMode>
  );
}

reportWebVitals();
